import { endPoints } from 'src/utils/apiEndpoints'
import axios from 'src/redux/axiosInterceptor'
import type { IPersonalDetailsPayload, UploadDocumentPayload } from './types'

export function requestDocumentUpload(data:UploadDocumentPayload) {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.documentModification,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function requestUploadPersonalDetails(data: IPersonalDetailsPayload) {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: `${endPoints.personalDetailsModification}`,
    data,
  })
}
